import React from "react";
import { StyledCell } from "./Cell";

const FilterCell = ({ onFilter, filteringEnabled, getMessage, ...props }) => {
  return <StyledCell {...props} />;
};

export default FilterCell;
